import { axios } from "../lib";
import * as endpoints from "./apiEndpoints";

class CustomerService {
  static loadCustomers(body) {
    const url = `${endpoints.BASE_URL}${endpoints.CUSTOMERS}`;
    return axios.post(url, body).then((response) => response.data);
  }

  static getCustomers(body) {
    const url = `${endpoints.BASE_URL}${endpoints.CUSTOMERS}/get-customers`;
    return axios.post(url, body).then((response) => response.data);
  }

  static getCustomer(id) {
    const url = `${endpoints.BASE_URL}${endpoints.CUSTOMERS}/${id}`;
    return axios.get(url).then((response) => response.data);
  }

  static createCustomer(customer) {
    const url = `${endpoints.BASE_URL}${endpoints.CUSTOMERS}/new`;
    const body = {
      customer
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static updateCustomer(customer) {
    const url = `${endpoints.BASE_URL}${endpoints.CUSTOMERS}/${customer.id}`;
    const body = {
      customer
    };

    return axios.put(url, body).then((response) => response.data);
  }

  static deleteCustomer(id) {
    const url = `${endpoints.BASE_URL}${endpoints.CUSTOMERS}/${id}`;
    return axios.delete(url).then((response) => response.data);
  }

  static createLocation(id, location) {
    const url = `${endpoints.BASE_URL}${endpoints.CUSTOMERS}/${id}/location`;
    const body = {
      location
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static updateLocation(id, location) {
    const url = `${endpoints.BASE_URL}${endpoints.CUSTOMERS}/${id}/location`;
    const body = {
      location
    };

    return axios.put(url, body).then((response) => response.data);
  }

  static deleteLocation(id, locationId) {
    const url = `${endpoints.BASE_URL}${endpoints.CUSTOMERS}/${id}/location/${locationId}`;

    return axios.delete(url).then((response) => response.data);
  }

  static createContact(id, contact) {
    const url = `${endpoints.BASE_URL}${endpoints.CUSTOMERS}/${id}/contact`;

    const body = {
      contact
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static updateContact(id, contact) {
    const url = `${endpoints.BASE_URL}${endpoints.CUSTOMERS}/${id}/contact`;

    const body = {
      contact
    };

    return axios.put(url, body).then((response) => response.data);
  }

  static deleteContact(id, contactId) {
    const url = `${endpoints.BASE_URL}${endpoints.CUSTOMERS}/${id}/contact/${contactId}`;
    return axios.delete(url).then((response) => response.data);
  }

  static createNote(id, note) {
    const url = `${endpoints.BASE_URL}${endpoints.CUSTOMERS}/${id}/note`;
    const body = {
      note
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static updateNote(id, note) {
    const url = `${endpoints.BASE_URL}${endpoints.CUSTOMERS}/${id}/note`;

    const body = { note };

    return axios.put(url, body).then((response) => response.data);
  }

  static deleteNote(id, noteId) {
    const url = `${endpoints.BASE_URL}${endpoints.CUSTOMERS}/${id}/note/${noteId}`;
    return axios.delete(url).then((response) => response.data);
  }

  static findByName(name) {
    const url = `${endpoints.BASE_URL}${endpoints.CUSTOMERS}/search?name${name}`;
    return axios.get(url).then((res) => res.data);
  }

  static findByNumber(number) {
    const url = `${endpoints.BASE_URL}${endpoints.CUSTOMERS}/search-number?number=${number}`;
    return axios.get(url).then((res) => res.data);
  }

  static loadInProgressCustomerProjects(params) {
    const url = `${endpoints.BASE_URL}${endpoints.CUSTOMERS}/in-progress-projects?${params}`;
    return axios.get(url).then((response) => response.data);
  }
}

export default CustomerService;
